import api from '@/configurations/service';
import * as types from './mutation-types';

export const handleModalDiscountLimit = async (context) => {
  context.commit(types.SET_MODAL_DISCOUNT_LIMIT);
};

export const setIssExibilityCollection = async (context) => {
  const { data } = await api().post('consumers.find-summary-iss-exibility');

  context.commit(types.SET_ISS_EXIBILITY_COLLECTION, data);
};

export const setTaxRegimeCollection = async (context) => {
  const { data } = await api().post('consumers.find-summary-tax-regime');

  context.commit(types.SET_TAX_REGIME_COLLECTION, data);
};

export const setNbsCollection = async (context) => {
  const { data } = await api().post('consumers.find-summary-service-nbs');

  context.commit(types.SET_NBS_COLLECTION, data);
};

export const setNfseNatureCodesCollection = async (context) => {
  const { data } = await api().post('consumers.find-summary-nfse-nature-codes');

  context.commit(types.SET_NFSE_NATURE_CODES_COLLECTION, data);
};

export const setCfopCollection = async (context, payload) => {
  const { data } = await api().post('fiscal.get-cfop', payload);

  context.commit(types.SET_CFOP_COLLECTION, data);
  return data;
};

export const setNfseNatureOfOperationCollection = async (context) => {
  const { data } = await api().post('consumers.find-summary-nfse-nature-of-operation');

  context.commit(types.SET_NFSE_NATURE_OF_OPERATION_COLLECTION, data);
};

export const setResponsibleRetentionCollection = async (context) => {
  const { data } = await api().post('consumers.find-summary-nfse-responsible-retention');

  context.commit(types.SET_NFSE_RESPONSIBLE_RETENTION_COLLECTION, data);
};
